{
    "use strict";

    window.addEventListener("load", () => {
        document.querySelectorAll(".custom-add-cart form").forEach(form => {
            if(form.classList.contains("set-event")) return;
            form.addEventListener("submit", e => {
                e.preventDefault();
                const cart = document.querySelector('cart-notification');

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];
                const formData = new FormData(e.currentTarget);
                formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                config.body = formData;
                const button = e.currentTarget.querySelector("button");
                button.disabled = true;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                        console.log(response.description);
                        return;
                        }
            
                        const cart = document.querySelector('cart-notification');
                        cart.renderContents(response);
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        button.disabled = false;
                    });
            });
            form.classList.add("set-event");
        });
    });
}